import { render } from "./CodeIcon16.vue.js?vue&type=template&id=4463e55c!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CodeIcon16.vue?vue&type=template&id=4463e55c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__